import React from "react";
import Email from "../Images/front.png";
import black from "../Images/back.png";

const Message = () => {
  return (
    <>
      <div className="message">
        <div className="message-heading">
          <h2>
            WE DELIVER THE RIGHT MESSAGE, TO THE RIGHT AUDIENCE, AT THE RIGHT
            TIME
          </h2>
          <p>
            Bud plans your email marketing campaigns to offer many advantages
            benefitting your business. Studies state that around 83% of
            consumers engage better through effective email campaigns. Our
            holistic email marketing services assure the following benefits:
          </p>
        </div>
        <div className="container1">
          <div className="message-grid-main">
            {/* start */}
            <div className="message-grid">
              <div className="message-grid-1">
                <div className="message-grid-main-img">
                  <div className="main-img">
                    <img src={black} alt="" />
                  </div>
                  <div className="image-content-message">
                    <h3>DIRECT COMMUNICATION</h3>
                    <p>
                      Email campaigns have one ability that other channels
                      don't. It creates valuable personal touches at scale. Our
                      email marketing campaigns allow your brand to communicate
                      not just to your targeted audience. We help you create a
                      sense of personal connection. We design email campaigns
                      for one-toone conversation, fostering trust and building
                      stronger relationships.
                    </p>
                  </div>
                  <div className="main-img-1">
                    <img src={Email} alt="" />
                  </div>
                </div>
              </div>
              {/* end  */}
              <div className="message-grid-1">
                <div className="message-grid-main-img">
                  <div className="main-img">
                    <img src={black} alt="" />
                  </div>
                  <div className="image-content-message">
                    <h3>COST-EFFECTIVE</h3>
                    <p>
                      Email campaigns have one ability that other channels
                      don't. It creates valuable personal touches at scale. Our
                      email marketing campaigns allow your brand to communicate
                      not just to your targeted audience. We help you create a
                      sense of personal connection. We design email campaigns
                      for one-toone conversation, fostering trust and building
                      stronger relationships.
                    </p>
                  </div>
                  <div className="main-img-1">
                    <img src={Email} alt="" />
                  </div>
                </div>
              </div>
              <div className="message-grid-1">
                <div className="message-grid-main-img">
                  <div className="main-img">
                    <img src={black} alt="" />
                  </div>
                  <div className="image-content-message">
                    <h3>TARGETED REACH</h3>
                    <p>
                      Email campaigns have one ability that other channels
                      don't. It creates valuable personal touches at scale. Our
                      email marketing campaigns allow your brand to communicate
                      not just to your targeted audience. We help you create a
                      sense of personal connection. We design email campaigns
                      for one-toone conversation, fostering trust and building
                      stronger relationships.
                    </p>
                  </div>
                  <div className="main-img-1">
                    <img src={Email} alt="" />
                  </div>
                </div>
              </div>
              <div className="message-grid-1">
                <div className="message-grid-main-img">
                  <div className="main-img">
                    <img src={black} alt="" />
                  </div>
                  <div className="image-content-message">
                    <h3>MEASURABLE RESULTS </h3>
                    <p>
                      Email campaigns have one ability that other channels
                      don't. It creates valuable personal touches at scale. Our
                      email marketing campaigns allow your brand to communicate
                      not just to your targeted audience. We help you create a
                      sense of personal connection. We design email campaigns
                      for one-toone conversation, fostering trust and building
                      stronger relationships.
                    </p>
                  </div>
                  <div className="main-img-1">
                    <img src={Email} alt="" />
                  </div>
                </div>
              </div>
              <div className="message-grid-1">
                <div className="message-grid-main-img">
                  <div className="main-img">
                    <img src={black} alt="" />
                  </div>
                  <div className="image-content-message">
                    <h3>AUTOMATION & EFFICIENCY</h3>
                    <p>
                      Email campaigns have one ability that other channels
                      don't. It creates valuable personal touches at scale. Our
                      email marketing campaigns allow your brand to communicate
                      not just to your targeted audience. We help you create a
                      sense of personal connection. We design email campaigns
                      for one-toone conversation, fostering trust and building
                      stronger relationships.
                    </p>
                  </div>
                  <div className="main-img-1">
                    <img src={Email} alt="" />
                  </div>
                </div>
              </div>
              <div className="message-grid-1">
                <div className="message-grid-main-img">
                  <div className="main-img">
                    <img src={black} alt="" />
                  </div>
                  <div className="image-content-message">
                    <h3>VERSATILITY & CREATIVITY</h3>
                    <p>
                      Email campaigns have one ability that other channels
                      don't. It creates valuable personal touches at scale. Our
                      email marketing campaigns allow your brand to communicate
                      not just to your targeted audience. We help you create a
                      sense of personal connection. We design email campaigns
                      for one-toone conversation, fostering trust and building
                      stronger relationships.
                    </p>
                  </div>
                  <div className="main-img-1">
                    <img src={Email} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="message-footer-text">
            <p>
              Bud, a top email marketing company, can enhance customer loyalty
              and retention. We foster relationships through cost-effective
              email marketing campaigns. We help you achieve greater mind share
              among our targeted audience. We stimulate timely, regular
              communications with existing customers, encouraging repeat
              purchases.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Message;
